import { render, staticRenderFns } from "./chatButton.vue?vue&type=template&id=0dfa75f6"
import script from "./chatButton.vue?vue&type=script&lang=js"
export * from "./chatButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Img: require('/vercel/path0/components/ui/img.vue').default,ChatForm: require('/vercel/path0/components/chatForm.vue').default})
